<template>
  <div style="flex: 1;margin-left: 24px">
    <a-result status="404" title="404" sub-title="Sorry, the page you visited does not exist.">
      <template #extra>
        <a-button type="primary">
          Back Home
        </a-button>
      </template>
    </a-result>
<!--    <a-card>
      <dol-erp-upload-img v-model.trim="fileData" @finished="finished" :paramsData="paramsData" serverType="2009"></dol-erp-upload-img>
    </a-card>-->

<!--    <a-card>
      <dol-upload-img v-model.trim="fileData" @finished="finished" :paramsData="paramsData" serverType="2009"></dol-upload-img>
    </a-card>-->

<!--    <a-card style="width: 400px">
      <div style="display: flex;justify-content: space-between;align-items: center;">
        <div>
          <div>提箱国家</div>
          <div class="test" ref="before1">中国1212</div>
        </div>
        <div @click="checkTest">
          <a-icon type="swap" />
        </div>
        <div>
          <div>还箱国家</div>
          <div class="test" ref="before2">俄罗斯222222222</div>
        </div>
      </div>
    </a-card>-->
  </div>
</template>

<script>
export default {
  name: "test",
  components: {},
  data(){
    return{
      paramsData: {
        "SYS_TYPE": "20011001",
        "TARGET_CATE": "20021001",
        "TARGET_TYPE": "20071001",
        "TARGET_ID":"10000006",
        "GUID_CODE":""
      },
      isCheck: false,
      fileData: [],
      fileDataList: []
    }
  },
  methods:{
    checkTest(){
      let width1 = 400 - 24*2 - this.$refs.before1.offsetWidth;
      let width2 = 400 - 24*2 - this.$refs.before2.offsetWidth;
      let width = width1 > width2 ? width2: width1;
      if(this.isCheck){
        this.$refs.before1.style = '';
        this.$refs.before2.style = '';
      }else {
        this.$refs.before1.style = `transform: translateX(${width}px)`;
        this.$refs.before2.style = `transform: translateX(-${width}px)`;
      }
      this.isCheck = !this.isCheck;
    },
    finishedList(data){
      this.finishedList = data['FILE_LIST'];
    },
    finished(data){
      this.paramsData['GUID_CODE'] = data?.['FILE_LIST']?.[0]?.['GUID_CODE'];
      this.fileData = data;
    }
  }
}
</script>

<style scoped>
.test {
  transition: transform 1s;
}
</style>